/* Copyright (c) 2020 BuserNet Consulting LLC   All rights reserved. */
import { createRouter, createWebHashHistory } from '@ionic/vue-router';
import routes from './routes';
import AppConst from './constants/app.constant';
import { setKeyValueInLocalStorage } from './services/localstorage/setKeyValueInLocalStorage';
import utilityService from './services/utility.service';
import capacitorService from './services/capacitor.service';
import authGuardService from './services/authGuard.service';
import tourService from './services/tour.service';
import { startSentinelWatcher } from './services/sentinal/sentinal';

const excludedViewLastVisit = ['app.login'];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.afterEach((toState) => {
  // Clean old data keys
  startSentinelWatcher(toState);
  utilityService.clearAuditFactory(toState.name);
  if (excludedViewLastVisit.indexOf(toState.name) === -1) {
    setKeyValueInLocalStorage(AppConst.localstorageConf.lastViewedStateKey, toState.name);
  }
  if (!capacitorService.isCapacitorMobileApp && window.location.hostname === 'localhost') {
    // For DEV no need to have analytics
    return;
  }
  if (window.ga) {
    window.ga('send', {
      hitType: 'pageview',
      title: toState.name,
      location: toState.name,
    });
  }
});
router.beforeEach((to, from, next) => {
  const $permissions = authGuardService.checkIfRouteIsAllowed(to);
  if ($permissions.isRouteAllowed) {
    if (to.name === AppConst.stateMap.avwxtab.key || to.name === AppConst.stateMap.workshops.key) {
      /**
       * If user is enters workshops or avwx tabs then just send him to dashboard
       */
      next({
        path: '/app/dashboard',
      });
    } else {
      next();
    }
  } else if (to.name !== 'app.login') {
    next({
      path: $permissions.shouldRedirectTo,
    });
  } else {
    next();
  }
  tourService.hideOverlay();
});

export default router;
